import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  template: require('./vehicle.imported-history.actions.component.html')
})
export class VehicleHistoryActionsComponent {
  @Input() record: any;

  @Output() onPrintClick: EventEmitter<any> = new EventEmitter();
  @Output() onNotesClick: EventEmitter<any> = new EventEmitter();

  company = this.sessionService.company();
  session = this.sessionService.base();

  constructor (
    private sessionService: SessionService
  ) {}
}